export const EXTENSION_TYPE_NAME = 'da-deviation-thumb';

//# sourceMappingURL=constants.js.map